import styled from "styled-components";

const ContainerSection = styled.div`
	background-color: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 6px;
	margin: 0 0 2rem 0;
`;

export const Container = styled(ContainerSection)``;
